// IntlFormat component
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import intlUtil from '../../../lib/intlutil.jsx'

class IntlFormat extends Component {
  static get propTypes () {
    return {
      onAfterLoad: PropTypes.func,
      intl: PropTypes.any
    }
  }

  static get defaultProps () {
    return {
      onAfterLoad: null,
      intl: null
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount () {
    intlUtil.setIntl(this.props.intl)
  }

  componentDidMount () {
    if (this.props.onAfterLoad) {
      this.props.onAfterLoad()
    }
  }

  componentWillUnmount () {
    intlUtil.setIntl(null)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.intl !== intlUtil.getIntl()) {
      intlUtil.setIntl(nextProps.intl)
    }
  }

  render () {
    return <div className='intl-format' />
  }
}

export default injectIntl(IntlFormat)
